/**
 * 	面对面赠券
 */
export default [
  {
    path: '/faceCoupon',
    component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceCoupon/Index.vue'),
    meta: { requiresAuth: true, title: '面对面赠券', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceCoupon/Coupons.vue'),
          meta: { title: '面对面赠券', role: true },
        },
        {
          path: 'couponSure',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceCoupon/CouponSure.vue'),
          meta: { title: '面对面赠券', role: true },
        },
        {
          path: 'CouponSuccess',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceCoupon/CouponSuccess.vue'),
          meta: { title: '面对面赠券', role: true },
        },
      ],
  },
];